import React, { useEffect, useState } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import urlUtils from 'utils/Url';
import { getContent } from 'services/api/Content/getContent';
import ReferrerShareLanding from 'components/Content/ReferrerShareLanding';

const ReferrerShareLandingPage = () => {
    const [content, setContent] = useState(null);

    const paths = urlUtils.getPathStrings();
    const idx = paths.indexOf('referafriend');
    const campaignCode = idx >= 0 ? paths[idx + 1] : undefined;

    useEffect(() => {
        if (Sephora.configurationSettings.referrerLandingPageEnhancements?.isEnabled !== true) {
            return;
        }

        if (!campaignCode) {
            setContent({});

            return;
        }

        const { country, language } = Sephora.renderQueryParams;

        const load = async () => {
            try {
                const { data } = await getContent({ language, country, path: `/advocacy/${campaignCode}` });
                setContent(data || {});
            } catch (e) {
                setContent({});
            }
        };

        load();
    }, [campaignCode]);

    if (!content) {
        return null;
    }

    return (
        <ReferrerShareLanding
            campaignCode={campaignCode}
            globalHeroBanner={content.globalHeroBanner}
            promoHeadline={content.biProfilePromoHeadline}
            promoInstructions={content.biProfilePromoInstructions}
            referralDisclaimer={content.referralDisclaimer}
        />
    );
};

export default wrapFunctionalComponent(ReferrerShareLandingPage, 'ReferrerShareLandingPage');
